import React from 'react';
import moment from 'moment-timezone';

import { formatRedemptionAmount } from '../../utils/dataFormatter';
import styles from './EarningItem.module.scss';

const EarningItem = (props) => {
  const {
    earning,
    role,
    onClick,
    isMerchantWithCustomLabels,
    canViewEarnings,
    showFullPrecision,
    earning: {
      dateTime,
      redeemedAmount,
      earnedAmount,
      id,
      merchantName,
      subMerchantLocation,
      redeemedLocation,
      status,
    },
  } = props;

  const locationToDisplay = isMerchantWithCustomLabels
    ? redeemedLocation || subMerchantLocation
    : subMerchantLocation;

  // Redemptions page shows the full 4-decimal amount; dashboards keep 2 decimals
  const formatAmount = (amount) =>
    showFullPrecision ? formatRedemptionAmount(amount) : amount?.toFixed(2);
  const amountCellClass = showFullPrecision ? styles.amount__cell : undefined;
  const amountTextClass = showFullPrecision
    ? styles.earned_amount_text__full
    : styles.earned_amount_text;

  const handleOnEarningSelect = () => {
    onClick && onClick(earning);
  };

  const rootStyle = onClick
    ? [styles.root__div, styles.clickable].join(' ')
    : styles.root__div;
  return (
    <tr className={rootStyle} onClick={handleOnEarningSelect}>
      <td>
        {moment(dateTime).tz('Asia/Kolkata').format('DD/MM/YYYY hh:mm A')}
      </td>
      <td>{id.toUpperCase()}</td>
      {role === 'ROLE_THYAGA_ADMINISTRATOR' ? <td>{merchantName}</td> : null}
      <td>{locationToDisplay}</td>
      <td>{status}</td>
      <td className={amountCellClass}>
        <p className={amountTextClass}>
          {formatAmount(redeemedAmount)}
        </p>
      </td>
      {!isMerchantWithCustomLabels && canViewEarnings && (
        <td className={amountCellClass}>
          <p className={amountTextClass}>
            {formatAmount(earnedAmount)}
          </p>
        </td>
      )}
    </tr>
  );
};

EarningItem.defaultProps = {
  onClick: null,
  isMerchantWithCustomLabels: false,
  canViewEarnings: true,
  showFullPrecision: false,
};

export default EarningItem;
